"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOnOutsideClick", {
    enumerable: true,
    get: ()=>_useOnOutsideClick.useOnOutsideClick
});
const _useOnOutsideClick = require("./useOnOutsideClick");
